module.exports = __webpack_public_path__ + "static/img/pdficon.218664a.png";


//////////////////
// WEBPACK FOOTER
// ./src/common/img/pdficon.png
// module id = 1PR+
// module chunks = 1